import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { usePickup } from '../../../../hooks/Pickup';
import { ModalTitle, ModalText } from './styled';
import { DefaultCollectContext } from '../..';

export const ModalInvoiceIssued = () => {
  const { Modal, closeModal } = useModal();
  const { enablePreCollection } = usePickup();

  const { openWishImportInvoiceModal, openPreCollectionModal } = useContext(
    DefaultCollectContext
  );

  const handleCloseModal = () => {
    closeModal();

    if (enablePreCollection) {
      openPreCollectionModal();
    }
  };

  return (
    <Modal closeFunction={handleCloseModal}>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}
      >
        <ModalTitle>Atenção</ModalTitle>

        <ModalText>Nota Fiscal já foi emitida?</ModalText>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32,
            marginTop: 16
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="attention"
            onClick={() => {
              handleCloseModal();
            }}
          >
            Não
          </Button>
          <Button
            type="button"
            variant="contained"
            onClick={() => {
              openWishImportInvoiceModal();
            }}
          >
            Sim
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
